import $ from 'jquery';

import Language from '../services/Language.js';
import utils from '../services/utils.js';

import { keyboardSettings } from '../componentSettings/KeyboardSettings.js';
import { CodeSendHandlersIds } from '../constant/CodeSendHandlersIds.js';
import greCaptcha from 'app/basic/greCaptcha';

import AppModalWidget from './AppModalWidget.js';

let inst;

class ConfirmCodeModalWidget {
    constructor() {
        if (!inst) {
            this.url = '';
            this.sendedData = {};
            this.modalObject = null;
            this.confirmCodeModalInputsEl = null;
            this.confirmCodeModalInput = null;
            this.wordCodeModalInput = null;
            this.emailCodeModalInput = null;
            this.confirmCodeModalForm = null;
            this.confirmCodeModalRecentEl = null;
            this.confirmCodeModalRecallEl = null;
            this.confirmCodeModalTimerEl = null;
            this.confirmCodeModalTimerWidth = 0;
            this.recentInterval = 0;
            this.settings = {};
            this.confirmUpdatedConditionsModal = null;
            this.requisiteNotFoundModalModal = null;
            this.extraOptions = {};
            inst = this;
        }
        return inst;
    }

    callback() {
    }

    showConfirmModal(url, sendedData, callback, userSettings, extraOptions={}) {
        if (this.recentInterval) {
            clearInterval(this.recentInterval);
        }
        this.extraOptions = extraOptions
        let that = this;
        let settings = {
            canRecall: false,
            canResend: false,
            handlers: [],
            restOfTimeout: 120,
            timeout: 120
        };
        if (typeof userSettings === 'object') {
            settings = $.extend(settings, userSettings);
        }
        this.settings = settings;
        this.url = url;
        this.sendedData = sendedData;
        if (typeof callback === 'function') {
            this.callback = callback;
        }
        const modalSettings = {};
        this.modalObject = $("<div />", {
            "class": "confirmCodeModal jsConfirmCodeModal"
        });

        /*
        if (this.settings.handlers && !~this.settings.handlers.indexOf(7)) {
            this.settings.handlers = [
                ...this.settings.handlers,
                7,
            ];
        }
        this.settings.googleCaptchaV3Action = 'check_is_human';
        this.settings.googleCaptchaV3HtmlKey = '6LeURIkUAAAAALHfmcXRaGOFRfQIubZCGyBxG7Ff';

        setTimeout(() => {
            this.confirmCodeModalInputsEl.find(`[data-handler_id=${CodeSendHandlersIds.HANDLER_WORD}]`).val('123456');
        }, 2000);
        */



        const captcha = (this.settings.handlers.indexOf(CodeSendHandlersIds.HANDLER_CAPTCHA) !== -1) ?
            this.renderCaptcha() : '';

        const googleQRCode = (this.settings.hasOwnProperty('googleQRCodeUrl')
            && this.settings.hasOwnProperty('googleSecretCode')) ?
            this.renderGoogleQRCode() : '';

        this.modalObject.html(
            googleQRCode + `<form id="confirmCodeModalForm" action="#" class="confirmCodeModal__form">`
                + (window.withdrawFormData ? `<div class="marginBottom--sm">` + Language.getLabel('L_CONFIRM_CODE_PAYMENT_DATA1')
                + `</div><div class="marginBottom--sm">` + Language.getLabel('L_CONFIRM_CODE_PAYMENT_DATA2', {
                    amount: window.withdrawFormData.amount,
                    cardNumber: window.withdrawFormData.cardNumber,
                    cardHolder: window.withdrawFormData.cardHolder,
                    currency: window.withdrawFormData.currency
                }) + `</div>` : ``) +
                `<div class="marginBottom--sm">` + Language.getLabel('L_ENTER_CONFIRM_CODE') + `</div>

                <div class="marginBottom--sm">` + Language.getLabel('L_FORMS_DESCRIPTION_SMS') + `</div>

                <input type="password" class="displayNone">
                ` + captcha + `
                <div class="confirmCodeModal__otherInputs">
                    <div class="confirmCodeModal__inputs jsConfirmCodeModalInputs">
                        ` + this.settings.handlers.map((handlerId) => {
                    return this.renderHandlerInputField(handlerId);
                }).join('') + `
                    </div>
                   
                    <div class="confirmCodeModal__controls">
                        <span id="confirmCodeModalTimer" class="button button--whitebg displayNone" style="cursor: default;" disabled="disabled">(0)</span>
                        <button id="confirmCodeModalRecent" class="button button--whitebg ` + (this.showButtonRecent(settings)  ? '' : ' displayNone') + `"><span class="icon-icon-refresh"> </span></button>
                    </div>
                    <div class="confirmCodeModal__actions">
                        <button class="button button--green modal-approve">` + Language.getLabel('L_CONFIRM') + `</button>
                        <button class="button button--orange modal-close jsCloseModal">` + Language.getLabel('L_CLOSE') + `</button>
                    </div>
                </div>
            </form>`
        );

        //document.body.appendChild(this.modalObject[0]);
        this.confirmCodeModalInputsEl = this.modalObject.find('.jsConfirmCodeModalInputs');
        this.confirmCodeModalCaptcha = this.modalObject.find('.confirmCodeModal__captcha');

        this.confirmCodeModalInput = this.modalObject.find("#confirmCodeModalInput");
        this.wordCodeModalInput = this.modalObject.find("#wordCodeModalInput");
        this.emailCodeModalInput = this.modalObject.find("#emailCodeModalInput");

        this.confirmCodeModalForm = this.modalObject.find("#confirmCodeModalForm");

        // this.settings.handlers


        if (!!~this.settings.handlers.indexOf(CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA)) {
            // this.loadGoogleCaptcha();
            const googleCaptchaV3Action = this.settings.googleCaptchaV3Action;
            const googleCaptchaV3HtmlKey = this.settings.googleCaptchaV3HtmlKey;
            if (googleCaptchaV3Action && googleCaptchaV3HtmlKey) {
                greCaptcha.execute(
                    googleCaptchaV3Action,
                    googleCaptchaV3HtmlKey,
                    (token) => {
                        this.confirmCodeModalInputsEl.find(`[name=approveCode_${CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA}]`).val(token);
                        handleSubmit();
                    },
                    (error) => {
                        this.clearCodeInputs();
                        this.close(() => {});
                        // this.handleCancel();
                    },
                );
            }
        }

        const handleSubmit = (e) => {
            e && e.preventDefault();
            const values = this.confirmCodeModalInputsEl
                .find('input')
                .get()
                .map((item) => {
                    return $(item).val();
                }).filter((value) => {
                    return value;
                });
            if (this.settings.handlers.length !== values.length) {
                return;
            }

            let sendedData;
            if (typeof  this.sendedData === 'string' || this.sendedData instanceof FormData) {
                sendedData = this.sendedData;
            } else {
                sendedData = Object.assign({}, this.sendedData);
            }
            let errors = [];
            pushDataFromInputs(this.confirmCodeModalInputsEl.find('input'));

            //for captcha
            if (this.confirmCodeModalCaptcha.length) {
                pushDataFromInputs(this.confirmCodeModalCaptcha.find('input'));
            }

            if (errors.length) {
                utils.app_noty({
                    type: 'error',
                    text: errors.join('<br>')
                });
            } else {
                const showModalAgain = true;
                this.sendRequest(this.url, sendedData, showModalAgain);
            }

            function pushDataFromInputs(inputsArr) {
                for (let el of inputsArr) {
                    let val = $.trim(el.value);
                    let handlerId = +el.dataset[ 'handler_id' ];
                    if (val) {
                        const elName = (handlerId === CodeSendHandlersIds.HANDLER_WORD) ?
                            'approveCode_' + CodeSendHandlersIds.HANDLER_WORD : el.name; // фикс для рандомного namе пинкода
                        if (typeof  that.sendedData === 'string') {
                            sendedData += '&' + elName + '=' + val;
                        } else if(sendedData instanceof FormData){
                            sendedData.append(elName, val)
                        } else {
                            sendedData[ elName ] = val;
                        }
                    } else {
                        errors.push(Language.getLabel('L_APPROVE_CODE_EMPTY_ERROR_' + handlerId));
                    }
                }
            }
        };

        this.confirmCodeModalForm.submit(handleSubmit);

        this.confirmCodeModalRecentEl = this.modalObject.find("#confirmCodeModalRecent");
        this.confirmCodeModalRecentEl.click(function (event) {
            event.preventDefault();
            that.sendRequest(utils.getLocalizeUrl(that.getUrlForResendConfirmCode(that.settings)), that.sendedData);
        });
        this.confirmCodeModalRecallEl = this.modalObject.find("#confirmCodeModalRecall");
        this.confirmCodeModalRecallEl.click(function (event) {
            event.preventDefault();
            let withCall = $.extend(that.sendedData, { call: true, csrf_token: csrfToken });
            that.sendRequest(utils.getLocalizeUrl(that.getUrlForResendConfirmCode(that.settings)), withCall);
        });

        this.confirmCodeModalTimerEl = this.modalObject.find("#confirmCodeModalTimer");

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
            if (this.showButtonRecent(this.settings) || this.showButtonRecall(this.settings)) {
                if (this.showButtonRecent(this.settings) && this.showButtonRecall(this.settings)) {
                    let calcWidth = 0;
                    calcWidth += this.confirmCodeModalRecallEl.outerWidth();
                    calcWidth += this.confirmCodeModalRecentEl.outerWidth();
                    if (calcWidth) {
                        let padding = parseFloat(this.confirmCodeModalTimerEl.css('padding-left'));
                        this.confirmCodeModalTimerWidth = calcWidth - 2 * padding;
                        this.confirmCodeModalTimerEl.width(this.confirmCodeModalTimerWidth);
                    }
                } else {
                    this.confirmCodeModalTimerEl.removeAttr('style');
                }
                this.recentAnimation();
            }
        };

        if (!utils.isMobileTablet()) {
            this.wordCodeModalInput.keyboard(Object.assign({}, keyboardSettings));
            this.wordCodeModalInput.keydown((e) => {
                e.preventDefault();
                return false;
            });
        }
        AppModalWidget.show(modalSettings);
    }

    getUrlForResendConfirmCode(settings) {
        let url = '/api/front/resend-code';
        if (settings.canResend && settings.handlers.indexOf(1) !== -1) {
            url = '/api/front/resend-code'
        }
        if (settings.canRecall && settings.handlers.indexOf(1) !== -1) {
            url = '/api/front/recall-sms-code'
        }
        if (settings.handlers.indexOf(4) !== -1) {
            url = '/api/front/resend-email-code'
        }
        if (settings.handlers.indexOf(10) !== -1) {
            url = '/api/front/resend-flashcall-code'
        }

        if (settings.handlers.indexOf(11) !== -1) {
            url = '/api/front/resend-voicecall-code'
        }

        return url;
    }

    showButtonRecent(settings) {
        return settings.canResend;
    }

    showButtonRecall(settings) {
        return settings.canRecall;
    }

    renderHandlerInputField(handlerId) {
        handlerId = +handlerId;
        let name = 'approveCode_' + handlerId;
        let placeholder = Language.getLabel('L_APPROVE_CODE_PLACEHOLDER_SHORT_' + handlerId);
        switch (handlerId) {
            case CodeSendHandlersIds.HANDLER_SMS:
                return `
                    <div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="tel" 
                            placeholder="` + placeholder + `"
                            autocomplete='off'  
                            data-handler_id="` + handlerId + `"
                        />
                    </div>
                `;
            case CodeSendHandlersIds.HANDLER_TELEGRAM:
                return `
                    <div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="text"
                            placeholder="` + placeholder + `"
                            autocomplete='off' 
                            data-handler_id="` + handlerId + `"
                        />
                    </div>
                `;
            case CodeSendHandlersIds.HANDLER_FLASHCALL:
                return `
                    <div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="text"
                            placeholder="` + placeholder + `"
                            autocomplete='off'  
                            data-handler_id="` + handlerId + `"
                        />
                    </div>
                `;
            case CodeSendHandlersIds.HANDLER_VOICECALL:
                return `
                    <div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="text"
                            placeholder="` + placeholder + `"
                            autocomplete='off'  
                            data-handler_id="` + handlerId + `"
                        />
                    </div>
                `;
            case CodeSendHandlersIds.HANDLER_GOOGLE:
                return `<div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="tel" 
                            placeholder="` + placeholder + `"
                            autocomplete='off'  
                            data-handler_id="` + handlerId + `"
                        />
                    </div>`;

            case CodeSendHandlersIds.HANDLER_WORD:
                return `<div class="confirmCodeModal__approveCode">
                            <input name="` + name + '_' + Math.random() + `"
                                type="text"
                                pattern="[0-9]*"
                                inputmode="numberic"
                                autocomplete='off' 
                                placeholder="` + placeholder + `"
                                data-handler_id="` + handlerId + `"
                                id="wordCodeModalInput"                                
                                autocapitalize="off"
                                spellcheck="false"
                                autocorrect="off"
                            />
                        </div>
                `;

            case CodeSendHandlersIds.HANDLER_EMAIL:
                return `<div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="tel" 
                            placeholder="` + placeholder + `"
                            autocomplete='off'  
                            data-handler_id="` + handlerId + `"
                        />
                    </div>`;

            case CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA:
                return `<input name="` + name + `"
                            type="hidden"                              
                            data-handler_id="` + handlerId + `"
                            value=""
                            autocomplete='off' 
                            />`;
        }
        return '';
    }

    renderCaptcha() {
        return `<div class="width-100">
                    <p class="confirmCodeModal__captchaDescription">${this.settings.captchaInfo}</p>
                    <div class="confirmCodeModal__approveCode confirmCodeModal__captcha">
                        <div class="confirmCodeModal__captchaWrapper">
                          <img src="${this.settings.captchaImg + '?rd=' + Math.random()}" id="confirmCodeModal__captcha" alt="Captcha">
                        </div>
                        <input name="approveCode_${CodeSendHandlersIds.HANDLER_CAPTCHA}"
                            type="text" 
                            placeholder="Сaptcha"
                            autocomplete='off'  
                            data-handler_id="${CodeSendHandlersIds.HANDLER_CAPTCHA}"
                        />
                    </div>

                </div>`;
    }

    renderGoogleQRCode() {
        return `<div class="textCenter">
                <img src="` + this.settings.googleQRCodeUrl + `" />
                <p class="box box--primary cursor-pointer jsHiddenText" id="jsGoogleQRCode">
                    ` + Language.getLabel('L_SHOW_HIDDEN_TEXT') + `
                </p>
                <p class="text--sm">` + Language.getLabel('L_SCAN_QR_CODE_WITH_GOOGLE') + `</p>
            </div><br/>`
    }

    afterShowHandler() {
        // if (!utils.isMobileTablet()) {
        //     if ($.inArray(CodeSendHandlersIds.HANDLER_WORD, this.settings.handlers) !== -1) {
        //         this.confirmCodeModalInputsEl.find('input[name="approveCode_' + CodeSendHandlersIds.HANDLER_WORD + '"]').keyboard(Object.assign({}, keyboardSettings));
        //         this.confirmCodeModalInputsEl.find('input[name="approveCode_' + CodeSendHandlersIds.HANDLER_WORD + '"]').keydown((e) => {
        //             e.preventDefault();
        //             return false;
        //         });
        //     }
        // }
        this.confirmCodeModalInputsEl.find('input').first().focus();

        const captcha = document.getElementById('confirmCodeModal__captcha');
        if (captcha) {
            captcha.parentNode.addEventListener('click', () => {
                captcha.src = this.settings.captchaImg + '?rd=' + Math.random();
            })
        }

        const inputWord = document.getElementById('wordCodeModalInput');
        if (inputWord) {
            inputWord.oncut = inputWord.oncopy = inputWord.onpaste = () => {
                return false;
            }
        }

        const googleQRCode = document.getElementById('jsGoogleQRCode');
        if (googleQRCode) {
            const googleSecretCode = this.settings.googleSecretCode;
            $(googleQRCode).on('click', function (e) {
                e.preventDefault();
                e.currentTarget.innerHTML = googleSecretCode;
                $(e.currentTarget).off('click')
                    .removeClass('cursor-pointer');
            });
        }
    }

    clearCodeInputs() {
        this.confirmCodeModalInputsEl.find('input').val('');
    }

    isCodesInput() {
        for (let el of this.confirmCodeModalInputsEl.find('input')) {
            if ($.trim(el.value)) {
                return true;
            }
        }
        return false;
    }

    sendRequest(url, sendedData, showModalAgain = false) {
        let that = this;
        this.confirmCodeModalForm.block();
        utils.app_post(url, sendedData, this.extraOptions).then((resp) => {
            if (resp.data) {
                if (!!resp.data.wrongConfirmCode) {
                    this.clearCodeInputs();
                }

                if (resp.type === 'sendConfirmCode') {
                    this.recentAnimation();
                }

                if (resp.type === 'updatedConditions' || resp.type === 'requisiteNotFound') {
                    for (let i in sendedData) {
                        if (sendedData.hasOwnProperty(i)) {
                            if (i.indexOf('approveCode') !== -1) {
                                delete sendedData[i];
                            }
                        }
                    }
                }
                if (resp.type === 'updatedConditions') {
                    if ($('.jsP2PPage').length) {
                        $('.jsP2PPage')[0].dispatchEvent(new CustomEvent("updatedMoneyOutForm", {
                            detail: {
                                'newPercent': resp.data.newPercent,
                                'newPrice': resp.data.newPrice,
                            }
                        }));
                    }

                    that.close(() => {
                        this.showUpdatedConditionsModal(url, sendedData, this.callback, resp);
                    });
                }

                if (resp.type === 'requisiteNotFound') {
                    if ($('.jsP2PPage').length) {
                        $('.jsP2PPage')[0].dispatchEvent(new Event("closeMoneyOutForm"));
                    }

                    that.close(() => {
                        this.showRequisiteNotFoundModal(url, sendedData, this.callback, resp);
                    });
                }
            }
            this.confirmCodeModalForm.unblock();
            if (resp.type === 'success' || (resp.type === 'error' && !resp.data.wrongConfirmCode)) {
                that.close(() => {
                    this.callback(resp);
                });
                return;
            }

            if (resp.type === 'error') {
                const captcha = document.getElementById('confirmCodeModal__captcha');
                if (captcha) {
                    captcha.src = this.settings.captchaImg + '?rd=' + Math.random();
                    document.querySelector(`input[data-handler_id="6"]`).value = ''
                }

            }

            if (showModalAgain && (resp.type === 'sendConfirmCode' && resp.data.settings.handlers.length)) {
                that.close(() => {
                    // utils.app_post_cc(this.url, this.sendedData, this.callback);
                    this.showConfirmModal(this.url, this.sendedData, this.callback, resp.data.settings)
                });
            }
        });
    }

    recentAnimation() {
        if (this.showButtonRecall(this.settings) || this.showButtonRecent(this.settings)) {
            let that = this;
            this.confirmCodeModalRecentEl.prop('disabled', true);
            this.confirmCodeModalRecallEl.prop('disabled', true);

            clearInterval(that.recentInterval);
            let timer = 0;
            if (this.settings.restOfTimeout !== undefined) {
                timer = this.settings.restOfTimeout;
                this.settings.restOfTimeout = undefined;
            } else {
                timer = this.settings.timeout;
            }

            that.recentInterval = setInterval(function () {
                if (--timer >= 0) {
                    that.confirmCodeModalTimerEl.html("(" + timer + ")").removeClass('displayNone');
                    that.confirmCodeModalRecentEl.addClass('displayNone');
                    that.confirmCodeModalRecallEl.addClass('displayNone');
                } else {
                    clearInterval(that.recentInterval);
                    that.confirmCodeModalTimerEl.addClass('displayNone');
                    if (that.showButtonRecent(that.settings)) {
                        that.confirmCodeModalRecentEl.removeClass('displayNone');
                        that.confirmCodeModalRecentEl.prop('disabled', false);
                    }
                    if (that.showButtonRecall(that.settings)) {
                        that.confirmCodeModalRecallEl.removeClass('displayNone');
                        that.confirmCodeModalRecallEl.prop('disabled', false);
                    }
                }
            }, 1000);
        }
    }

    close(cb) {
        if (this.modalObject) {
            AppModalWidget.close(cb);
        }
    }

    showUpdatedConditionsModal(url, sendedData, callback, userSettings) {
        let that = this;
        let oldFullCommission = sendedData.fullCommission;
        this.settings = typeof userSettings === 'object' ? userSettings.data : {newPercent: 0, newPrice: 0};
        this.url = url;
        this.sendedData = sendedData;
        this.sendedData.fullCommission = this.settings.newPercent;
        this.sendedData.newPrice = this.settings.newPrice;
        if (typeof callback === 'function') {
            this.callback = callback;
        }

        const modalSettings = {};

        this.modalObject = $("<div />", {
            "class": "systemModal jsConfirmUpdatedConditionsModal"
        });

        this.modalObject.html(
            `<form id="confirmUpdatedConditionsModal" action="#" class="systemModal__form">
                    <div class="systemModal__controls">
                        `+ userSettings.text + `
                    </div>
                    <div class="systemModal__actions">
                        <button class="button button--green modal-approve">` + Language.getLabel('L_CONFIRM') + `</button>
                        <button class="button button--orange modal-close jsCloseModal">` + Language.getLabel('L_CLOSE') + `</button>
                    </div>
                </div>
            </form>`
        );

        this.confirmUpdatedConditionsModal = this.modalObject.find("#confirmUpdatedConditionsModal");

        const handleSubmit = (e) => {
            e && e.preventDefault();
            let showModalAgain = true;
            let that = this;
            this.confirmUpdatedConditionsModal.block();
            utils.app_post(url, sendedData).then((resp) => {
                if (resp.type === 'updatedConditions' && $('.jsP2PPage').length) {
                    $('.jsP2PPage')[0].dispatchEvent(new CustomEvent("updatedMoneyOutForm", {
                        detail: {
                            'newPercent': resp.data.newPercent,
                            'newPrice': resp.data.newPrice
                        }
                    }));
                } else {
                    showModalAgain = false;
                }

                this.confirmUpdatedConditionsModal.unblock();

                if (resp.type === 'sendConfirmCode') {
                    that.close(() => {
                        this.showConfirmModal(this.url, this.sendedData, this.callback, resp.data.settings)
                    });
                }
                if (resp.type === 'requisiteNotFound') {
                    that.close(() => {
                        this.showRequisiteNotFoundModal(url, sendedData, this.callback, resp);
                    });
                }

                if (resp.type === 'success' || resp.type === 'error') {
                    that.close(() => {
                        this.callback(resp);
                    });
                    return;
                }

                if (showModalAgain) {
                    that.close(() => {
                        this.showUpdatedConditionsModal(this.url, this.sendedData, this.callback, resp)
                    });
                }
            });
        };

        this.confirmUpdatedConditionsModal.submit(handleSubmit);

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }

    showRequisiteNotFoundModal(url, sendedData, callback, userSettings) {
        let that = this;
        this.url = url;
        this.sendedData = sendedData;
        if (typeof callback === 'function') {
            this.callback = callback;
        }

        const modalSettings = {};

        this.modalObject = $("<div />", {
            "class": "systemModal jsRequisiteNotFoundModal"
        });

        this.modalObject.html(
            `<form id="requisiteNotFoundModalModal" action="#" class="systemModal__form">
                    <div class="systemModal__controls">
                        `+ Language.getLabel('L_MERCHANT_DISABLED_ACCEPTANCE_ORDERS') + `
                    </div>
                    <div class="systemModal__actions">
                        <button class="button button--blue__light modal-approve">` + Language.getLabel('L_UPDATE_LIST_OF_MERCHANTS') + `</button>
                        <button class="button button--orange modal-close jsCloseModal">` + Language.getLabel('L_CLOSE') + `</button>
                    </div>
                </div>
            </form>`
        );

        this.requisiteNotFoundModalModal = this.modalObject.find("#requisiteNotFoundModalModal");

        const handleSubmit = (e) => {
            e && e.preventDefault();
            if ($('.jsMerchantDataTable').length) {
                $('.jsMerchantDataTable')[0].dispatchEvent(new Event("updatedTraderTable"));

            }
            if ($('.jsP2PPage').length) {
                $('.jsP2PPage')[0].dispatchEvent(new Event("closeMoneyOutForm"));
            }

            that.close(() => {});
        };

        this.requisiteNotFoundModalModal.submit(handleSubmit);

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }
}

export default new ConfirmCodeModalWidget();